import { CenteredContainer } from "@snapchat/web-core-ui";
import { LensPreviewCard } from "../../LensPreviewCard";
import { MOBILE_GROUP_ID } from "../liveLensConfig";
import styles from "./MobileLensProfile.module.css";
import { FreestandingMobileShareIcon } from "@snapchat/web-sharing";
import { grafanaBasePrefix } from "../../../../lib/grafana";
import { incrementCounter } from "@snapchat/web-graphene-reporting";
import { generateShareLensURL } from "../../../../lib/urlUtils";
import { useIntl } from "react-intl";
/**
 * Where can I view this component?
 * On mobile:
 * `/0cc5eff37cc1485889a62a7696b27e10`
 * `/unlock?type=SNAPCODE&uuid=b8c89687c5194c3fb5db63d33eb04617&metadata=01`
 */
export function MobileLensProfile(props) {
    const { lensDisplayInfo } = props;
    const intl = useIntl();
    const shareUrl = generateShareLensURL(lensDisplayInfo.scannableUuid || "");
    const shareTitle = intl.formatMessage({
        defaultMessage: "Share Lens",
        description: "Title for a share section of the page which allow users to share the Lens with other people",
    });
    return (<div className={styles.container}>
      <CenteredContainer>
        <LensPreviewCard lensGroupId={MOBILE_GROUP_ID} lensId={lensDisplayInfo.lensId} lensName={lensDisplayInfo.lensName} previewImageUrl={lensDisplayInfo.lensPreviewImageUrl} previewVideoUrl={lensDisplayInfo.lensPreviewVideoUrl} lensCreatorTags={lensDisplayInfo.lensCreatorSearchTags} pageType={props.pageMetadata.pageType} locale={props.locale} iconUrl={lensDisplayInfo.iconUrl} isMobile userProfileUrl={lensDisplayInfo.userProfileUrl} lensCreatorDisplayName={lensDisplayInfo.lensCreatorDisplayName} snapcodeImageUrl={props.pageLinks.snapcodeImageUrl} spotlightOption={props.spotlightOption} spotlightsUsingThisLens={props.spotlightsUsingThisLens} moreLenses={props.moreLenses} openInSnapchatLink={props.openInSnapchatLink}/>
        <div className={styles.shareIconWrapper}>
          <FreestandingMobileShareIcon incrementCounter={incrementCounter} pageName={`${grafanaBasePrefix}.LensProfile.Mobile`} pageType={props.pageMetadata.pageType} shareUrl={shareUrl} shareTitle={shareTitle} withTransparency={false} lightMode withEmbed/>
        </div>
      </CenteredContainer>
    </div>);
}
